import { type ExcalidrawFontFaceDescriptor } from "../Fonts";

import Regular from "./Teko-Regular.woff2";

export const TekoRegularFontFaces: ExcalidrawFontFaceDescriptor[] = [
  { uri: Regular },
];
